<template>
  <div class="flex items-center">
    <b class="text-[#5c7a2e] pr-1">
      {{ numberWithPrecision(ok_percent || 0, 0) }}%
    </b>
    <div
      class="h-1.5 bg-red-500 overflow-hidden rounded-full"
      :class="'w-' + min_width"
    >
      <div class="bg-[#5c7a2e] h-1.5" :style="{ width: `${ok_percent}%` }"></div>
    </div>
    <b class="text-red-600 pl-1">
      {{
        numberWithPrecision(
          ( this.err_percent || 100 - (this.ok_percent ?? 0) ) || 0,
          0
        )
      }}%
    </b>
  </div>
</template>

<script>
export default {
  name: "PercentBar",
  props: {
    ok_percent: { required: true, default: 0 },
    err_percent: { default: 0 },
    min_width: { default: "48" }
  }
};
</script>
